import RevuudApproved from './RevuudApproved';

export default RevuudApproved;
